// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const PUBLISH_MESSAGE = createAsyncActionTypes('PUBLISH_MESSAGE');